import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { TitleWithQuestion } from '@/common/TitleWithQuestion';
import StudentGradedQuizSubmissionsTable from '@/tables/StudentGradedQuizSubmissionsTable';
import StudentQuizSubmissionsTable from '@/tables/StudentQuizSubmissionsTable';
import { GroupHeaderWrapper } from '~/styles/layoutElements';

export const Route = createFileRoute(
  '/_app/_users/members/$memberId/course-study/quizzes/',
)({
  component: QuizzesScreen,
});

function QuizzesScreen() {
  const { t } = useTranslation();
  const { memberId } = Route.useParams();
  const studentId = Number.parseInt(memberId, 10);

  return (
    <Container>
      <GroupHeaderWrapper>
        <TitleWithQuestion
          title={t('wbs.pending-submissions')}
          placement="course_study"
        />
      </GroupHeaderWrapper>
      <StudentQuizSubmissionsTable studentId={studentId} />
      <div style={{ paddingTop: '134px' }}>
        <GroupHeaderWrapper>
          {/* The catalogue string already ends with a colon. */}
          <TitleWithQuestion
            title={t('lessons.all-graded-submissions')}
            placement="course_study"
          />
        </GroupHeaderWrapper>
      </div>
      <StudentGradedQuizSubmissionsTable studentId={studentId} />
    </Container>
  );
}

const Container = styled.div`
  padding-bottom: 50px;
`;
